import * as t from 'io-ts';

export const AmenityDynamicType = t.type({
    name: t.union([t.string, t.null]),
    notes: t.union([t.string, t.null]),
});

export type Amenity = t.TypeOf<typeof AmenityDynamicType>;
